import { withOidcSecure } from '@axa-fr/react-oidc'
import React, { useEffect, useState } from 'react'
import HomeLayout from '../../../Layout/HomeLayout';
import HomeHeader from '../../../CustomComponents/HomeHeader';
import Loader from '../../../CustomComponents/Loader';
import { useTranslation } from 'react-i18next';  
import Modal from '../../../CustomComponents/Modal';
import { useDispatch, useSelector } from 'react-redux'
import { appTheme } from '../../../../helpers/utils/Utils';
import SavinGoalFields from './SavingGoalFields';
import SuccessSpendAlertSet from '../SpendSenseAlerts/SuccessSpendAlertSet';
import SpendAlertError from '../SpendSenseAlerts/SpendAlertError';
import SavingGoalAmountField from './SavingGoalAmountField';
import { addLineBreaks, handleAmountInputLimitTo2decimal } from '../../../../utils';
import SavingGoalsAleart from './SavingGoalsAleart';
import SavingGoalErrorModal from './SavingGoalErrorModal';
import { useNavigate } from 'react-router';
import { addLineBreaksNew } from "../../../../../src/utils/index";
import ExistedSavingGoalAlertModal from './ExistedSavingGoalAlertModal';
import SavingGoaldDateField from './SavingGoaldDateField';
import SavingGoalNotificationField from './SavingGoalNotificationField';
import SavingGoalConfirmation from './SavingGoalConfirmation';
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';
 
 
export const AddSavingGoal = ({ openPersonalInfoSummaryClick,backToStudenEmailVerification, openTermsandConditionsonClick, getDataFromPersonalInfo, email, password,handleOpenCreatePassword }) => {
  const HeadingStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--head-modal-clr)]";
  const SubHeadingStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-sub-text-clr)] md:w-[80%]";
  const SubHeadingStylesError = "Hanken Grotesk modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-sub-text-clr)] md:w-[80%]";
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const ModalValue = useSelector(state => state.modalvalueSavingGoal);
  const ErrorModalValue = useSelector(state => state.errorModalvalueSavingGoal);
  const appThemeData = appTheme(kudzuPlusTrue)
  const { t } = useTranslation();
  useDocumentTitle(t('page_title_add_savings_goal'));
  
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [alertCard, setAlertCard] = useState("SavingGoalFields");
  const [spendAlertStatus, setSpendAlertStatus] = useState("")
  const [isSubErrMsg, setIsSubErrMsg]=useState(true)
  const [spendingAlertErrorMsg, setSpendingAlertErrorMsg] = useState("You already have a SpendSense Alert for this amount and time frame.")
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [isSuccessfullModalOpen, setIsSuccessfullModalOpen] = useState(false);
  const [isAmountCard, setIsAmountCard] = useState(false);
  const [nameCard, setNameCard] = useState(true);
  const [dateCard, setDateCard] = useState(false);
  const [NotificationCard, setNotificationCard] = useState(false);
  const [previewCard, setPreviewCard] = useState(false);
  const [showSavingGoalRepossessModal, setShowSavingGoalRepossessModal] = useState(false);
  const navigate = useNavigate();
  const responseMsg = useSelector(state => state.savingGoalResonseMsg)
  const [openExistedErrorModal, setOpenExistedErrorModal] = useState(false)
    
 
  const setAlertCardFun = (value) => {
      setAlertCard(value)
  }
  const handleErrorModalClose = (value) => {
    setOpenExistedErrorModal(value)
  }
  const setSavingGoalStatusFun = (value) => {
      if (value === "success") {
          openSuccessfullModal();
      }else if(value === "existedName"){
        openExistingNameErrorModal()
      }
      else{
          openErrorModal();
      }
  }
 
  const displayAmountCard = () => {
      setIsAmountCard(true);
  }
 
  const hideAmountCard = () => {
      setIsAmountCard(false);
  }
 
  const displaynameCard = () => {
    setNameCard(true);
  }
 
  const hideNameCard = () => {
    setNameCard(false);
  }
    
  
    useEffect(() => {
        switch (alertCard) {
            case "SavingGoalConfirmation":
                hideAmountCard();
                hideNameCard();
                setDateCard(false);
                setNotificationCard(false);
                setPreviewCard(true);
                break;
            case "SavingGoalNotificationField":
                hideAmountCard();
                hideNameCard();
                setDateCard(false);
                setNotificationCard(true);
                setPreviewCard(false);
                break;
            case "SavingGoalDateField":
                hideAmountCard();
                hideNameCard();
                setDateCard(true);
                setNotificationCard(false);
                setPreviewCard(false);
                setShowSavingGoalRepossessModal(false);
                break;
            case "SavingGoalAmountField":
                displayAmountCard();
                hideNameCard();
                setDateCard(false);
                setNotificationCard(false);
                setPreviewCard(false);
                setShowSavingGoalRepossessModal(false);
                break;
            case "SavingGoalFields":
                displaynameCard();
                hideAmountCard();
                setDateCard(false);
                setNotificationCard(false);
                setPreviewCard(false);
                setShowSavingGoalRepossessModal(false);
                break;
        
        }
 
    }, [alertCard])
 
 
 
  const cardFooter = (handleBackClick, handleNextClick, button1, button2, isNextActive=true) => {
      return (
          <div className='flex flex-row sm:justify-end justify-between items-center  md:gap-16 sm:gap-10 sm:mx-0 mx-4 lg:pb-[5rem] md:pb-[4rem] sm:pb-[3rem] pb-[3rem]'>
              <p className='font-hanken-grotesk font-[600] sm:font-[700] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
              leading-[26px] sm:leading-[13px]  md:leading-[18px]
              text-[var(--backdrop-color)] cursor-pointer capitalize' onClick={handleBackClick}
                  tabIndex={0}
                  onKeyDown={(e) => {
                      if (e.key === "Enter") handleBackClick();
                  }}
              >{button1 || `${t("back")}`}</p>
              <div>
                  <div className='flex flex-row justify-end  gap-2 cursor-pointer items-center'>
                      <button className={`font-hanken-grotesk font-[600] sm:font-[700] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                       leading-[26px]  sm:leading-[13px]
                        md:leading-[18px] ${!isNextActive ? 'text-[var(--nextdrop-color)] opacity-55' : 'text-[var(--nextAct-color)]'} `}
                          onClick={handleNextClick}
                          tabIndex={0}
                          onKeyDown={(e) => {
                              if (e.key === "Enter") handleNextClick();
                          }}
                          disabled={!isNextActive}
                      >{button2 || `${t("next")}`}</button>
                      <img src={!isNextActive ? appThemeData.NextArrowInactive : appThemeData.RightArrowActive} alt="" className='h-[12px] w-[12px]
                      sm:h-[10px] sm:w-[11px] md:h-[15px] md:w-[17px]' />
                  </div>
              </div>
          </div>
      )
  }
 
 
 
 
  const openSuccessfullModal = () => {
    dispatch({ type: 'MODAL_SAVING_GOAL', payload: { modalvalueSavingGoal: true } });
  };
  const closeSuccessfullModal = () => {
    dispatch({ type: 'MODAL_SAVING_GOAL', payload: { modalvalueSavingGoal: false } });
    dispatch({ type: "RESET_SAVING_GOALS" })
    navigate('/Toolkit/SavingGoals');
    setAlertCard('SavingGoalFields')
  };
  const closeSavingGoalSuccessModal = () => {
    dispatch({ type: 'MODAL_SAVING_GOAL', payload: { modalvalueSavingGoal: false } });
    dispatch({ type: "RESET_SAVING_GOALS" })
    navigate('/Toolkit/SavingGoals/ManageSavingGoal');
  };
 
  // Error modal
 
  const openErrorModal = () => {
    //   setIsErrorModalOpen(true);
    dispatch({ type: 'ERROR_MODAL_SAVING_GOAL', payload: { errorModalvalueSavingGoal: true } });
  };
  const openExistingNameErrorModal = () => {
    setOpenExistedErrorModal(true);
  };
 
  const closeErrorModal = () => {
    dispatch({ type: 'ERROR_MODAL_SAVING_GOAL', payload: { errorModalvalueSavingGoal: false } });
  };
  const closeExistedNameModal = () => {
    setOpenExistedErrorModal(false)
    setAlertCard('SavingGoalFields')
  };
 
 
 
  return (
      <HomeLayout>
          <HomeHeader heading={addLineBreaks(t("Work_Towards"))}
              isHeaderCaption={true} />
          <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
          animate__animated animate__fadeInRight '>
              {isAmountCard && <SavingGoalAmountField  cardFooter={cardFooter} onBack={setAlertCardFun} onNext={setAlertCardFun} />}
               {nameCard && <SavinGoalFields   cardFooter={cardFooter}  onBack={setAlertCardFun} onNext={setAlertCardFun} />}
               {dateCard && <SavingGoaldDateField   cardFooter={cardFooter}  onBack={setAlertCardFun} onNext={setAlertCardFun} />}
               {NotificationCard && <SavingGoalNotificationField   cardFooter={cardFooter}  onBack={setAlertCardFun} onNext={setAlertCardFun} />}
               {previewCard && <SavingGoalConfirmation cardFooter={cardFooter}   onBack={setAlertCardFun} onSave={setSavingGoalStatusFun} />}
          </div>
 
          <Modal
 
 
              isOpen={isSuccessfullModalOpen}
              onClose={closeSuccessfullModal}
              alignItems={'items-center'}
              isClimbg={true}
              title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('success')}</p>}
              subtitle={
                  <p>
                      <span className={`${HeadingStyles} visible sm:hidden`}>{t('success')}</span><span className={SubHeadingStyles}>{t('success_spend_alert_msg')}</span>
                  </p>}
              content={<div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6"><SuccessSpendAlertSet /></div>}
          />
          <Modal
              isOpen={ModalValue}
              onClose={closeSavingGoalSuccessModal}
              alignItems={'items-center'}
              isClimbg={true}
            //   title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('success')}</p>}
              subtitle={
                  <p>
                      <span className={SubHeadingStyles}><span className={`${HeadingStyles}`}>{t('success')} </span>{t('Saving_Goal_Created')}</span>
                  </p>}
              content={<div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6"><SavingGoalsAleart  onBack={setAlertCardFun} /></div>}
          />
          <Modal
              isOpen={openExistedErrorModal}
              onClose={closeExistedNameModal}
              alignItems={'items-center'}
              isClimbg={true}
            //   title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('success')}</p>}
              subtitle={
                  <p>
                      <span className={SubHeadingStyles}><span className={`${HeadingStyles}`}>{t('oops_exclamation')} </span>{t('plz_try_again')}</span>
                  </p>}
              content={<div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6"><ExistedSavingGoalAlertModal  onBack={setAlertCardFun} modalClose={handleErrorModalClose} /></div>}
          />
 
          <Modal
              isOpen={ErrorModalValue}
              onClose={closeErrorModal}
              alignItems={'items-center'}
              isClimbg={true}
              title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('oops_exclamation')}</p>}
              subtitle={
                  <p>
                      <span className={`${HeadingStyles} visible sm:hidden`}>{t('oops_exclamation')}</span><span className={SubHeadingStyles}>{responseMsg}</span>
                  </p>}
              content={<div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6"><SavingGoalErrorModal onBack={setAlertCardFun} /></div>}
          />
          {isLoading && <Loader />}
      </HomeLayout >
  )
}
 
export default withOidcSecure(AddSavingGoal);